import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["input", "dropdownButton", "submitButton"]
  }

  static get values() {
    return { campaignId: Number, step: Number }
  }

  send() {
    this.dropdownButtonTarget.setAttribute("disabled", "true")
    this.submitButtonTarget.setAttribute("disabled", "true")

    fetch(`/campaigns/${this.campaignIdValue}/send-test`, {
      credentials: "same-origin",
      method: "POST",
      headers: { "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"), "Content-Type": "application/json" },
      body: JSON.stringify({ step: this.stepValue, email: this.inputTarget.value }),
    })
      .then((response) => {
        this.dropdownButtonTarget.removeAttribute("disabled")
        this.submitButtonTarget.removeAttribute("disabled")

        if (!response.ok) {
          throw response.json()
        }

        return response.json()
      })
      .then((json) => {
        this.dropdownButtonTarget.click()

        App.displayFlash("success", json.message)
      })
      .catch((error) => {
        error.then((data) => {
          App.displayFlash("danger", data.message)
        })
      })
  }
}
